module.exports = __webpack_public_path__ + "images/p_games_e281ae012e5ffcd0a4be91db0519c35b.png";